import type { SourceManagedItem } from '@/utilities/sourceManagedItem.types';

export const getSourceManagedItemName = (sourceManagedItem?: SourceManagedItem) =>
  sourceManagedItem?.name || sourceManagedItem?.id;

export const getSourceManagedItemOpenLink = (
  sourceManagedItem: SourceManagedItem | undefined,
  openSourceItem: (() => void) | undefined,
) => (getSourceManagedItemName(sourceManagedItem) && sourceManagedItem?.id ? openSourceItem : undefined);
